/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Partner_Connectors_Validation_Secret_DuplicateInputs */



/**
* | output |
* | --- |
* | "Each secret name may appear only once" |
*
* @param {Partner_Connectors_Validation_Secret_DuplicateInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_connectors_validation_secret_duplicate = /** @type {((inputs?: Partner_Connectors_Validation_Secret_DuplicateInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Connectors_Validation_Secret_DuplicateInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Jeder Secret-Name darf nur einmal vorkommen")
	return /** @type {LocalizedString} */ ("Each secret name may appear only once")
});